import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import { OnChange } from 'react-final-form-listeners'
import { Select } from 'antd';
// Local deps
import './RFFSelectStateProv.scss';
// import RFFRadio from './index';
import States from '../../../config/fiftyStates_copy.json';
import CandianProvinces from '../../../config/candianProvinces.json';

const Option = Select.Option;

function RFFSelectStateProvField({
  input,
  meta,
  labelCol,
  inputCol,
  errorCol,
  label,
  isRequired,
  changeSelectValue,
  mode,
  cntry,
  defaultValue,
  onStateProvChange,
  ...otherProps
}) {
  const _OnChange = value => {
    if (changeSelectValue) {
      changeSelectValue(input, value);
    } else {
      input.onChange(value);

    }
  };

  const states = Object.keys(States).map(state => (
    <Option value={state} label={state} key={state}>{States[state]}</Option>
  ));

  const candianProvinces = Object.keys(CandianProvinces).map(candianProvince => (
    <Option value={candianProvince} label={candianProvince}>{CandianProvinces[candianProvince]}</Option>
  ));

  return (
    <div className="nf-rff-input-field">
      <Row className="nf-rff-input-field__row">
        {/* <!-- LABEL --> */}
        {label && (
          <Col {...labelCol}>
            <Label className="nf-rff-input-field__label" htmlFor={input.name}>
              {label}
              {isRequired && (
                <span className="nf-rff-input-field__required">*</span>
              )}
            </Label>
          </Col>
        )}

        {/* <!-- INPUT --> */}
        <Col {...inputCol}>
          <Select
            className="nf-rff-input-field__input"
            optionLabelProp="label"
            {...input}
            {...otherProps}
            onChange={_OnChange}
          >
            {cntry === "USA" && states}
            {cntry === "CAN" && candianProvinces}
          </Select>
        </Col>

        {/* <!-- ERROR -> */}
        {meta.touched &&
          meta.error && (
            <Col {...errorCol}>
              <div className="nf-rff-input-field__error">{meta.error}</div>
            </Col>
          )}
      </Row>
      {onStateProvChange && <OnChange name={input.name}>
        {(value) => {
          onStateProvChange(value)
        }}
      </OnChange>}
    </div>
  );
}

RFFSelectStateProvField.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6, className: 'text-left' },
  errorCol: { md: 3 },
  isRequired: false,
  mode: '',
  defaultValue: [],
};

RFFSelectStateProvField.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  // options: PropTypes.array.isRequired,
  cntry: PropTypes.string.isRequired,
  mode: PropTypes.string,
  defaultValue: PropTypes.string,
  changeSelectValue: PropTypes.func.isRequired,
  onStateProvChange: PropTypes.func.isRequired,
};

export default RFFSelectStateProvField;



// WEBPACK FOOTER //
// ./src/components/form/RFFSelectSateProv/RFFSelectStateProv.jsx